export default __webpack_public_path__ + "static/media/gallery-glow.ee6292db.png";